import { render, staticRenderFns } from "./BrochureCard.vue?vue&type=template&id=6db7335c&"
import script from "./BrochureCard.ts?vue&type=script&lang=ts&"
export * from "./BrochureCard.ts?vue&type=script&lang=ts&"
import style0 from "./BrochureCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports